import React from "react";
import { Routes, Route } from "react-router-dom";
import ClientsPage from "../pages/ClientsPage";
//import ClientDetailPage from "../pages/ClientDetailPage";

const ClientsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<ClientsPage />} />
      <Route path=":id" element={<ClientsPage />} />
    </Routes>
  );
};

export default ClientsRoutes;
